import React, { memo } from "react";
import { DigioAuthenticationComponent } from "./DigioAuthenticationComponent";

export declare type KycDigioMobileProps = {
    onSuccess: (response: any) => void;
    onCancel: (response: any) => void;
    options: any;
    digioDocumentId: string;
    webUrl?: string;
    identifier: string;
    digioToken: string;
    successLottie?: any;
};

const DigioMobileIntegration: React.FunctionComponent<
    KycDigioMobileProps
> = ({
         digioDocumentId,
         digioToken,
         identifier,
         options,
         onSuccess,
         onCancel
     }) => {
    const onSuccessReceived = async (response: any) => {
        if(response.type !== undefined || response.error !== undefined) {
            onSuccess && onSuccess(response)
        }
    }

    const onCancelCallback = async (response: any) => {
        onCancel && onCancel(response)
    }

        return (
            <DigioAuthenticationComponent onSuccess={onSuccessReceived} onCancel={onCancelCallback}
                options={options}
                digioDocumentId={digioDocumentId} digioToken={digioToken} identifier={identifier}
            />
        )
    }

export default memo(DigioMobileIntegration);
export { DigioMobileIntegration };
